// Colores unificados para cada tipo de servicio en toda la app
export const SERVICIO_COLORES = {
  G:     { bg: "#dcfce7", color: "#15803d", border: "#86efac" },
  TI:    { bg: "#dbeafe", color: "#1d4ed8", border: "#93c5fd" },
  PLUS:  { bg: "#ffedd5", color: "#c2410c", border: "#fdba74" },
  PRIME: { bg: "#f3e8ff", color: "#7e22ce", border: "#d8b4fe" },
  YP:    { bg: "#fce7f3", color: "#be185d", border: "#f9a8d4" },
  CTA:   { bg: "#ccfbf1", color: "#0f766e", border: "#5eead4" },
};

export const getServicioStyle = (servicio) =>
  SERVICIO_COLORES[servicio] || { bg: "#f3f4f6", color: "#374151", border: "#d1d5db" };
